export default __webpack_public_path__ + "static/media/userIcon_profile.40aa65a6.svg";